import { useMainHubStoreState } from '@/store/main-hub.store';

import { StageZero } from '../loan-stages/stage-0/stage-zero';
import { StageOne } from '../loan-stages/stage-1/stage-one';
import { StageOneLiberis } from '../loan-stages/stage-1/stage-one-liberis';
import { StageTwo } from '../loan-stages/stage-2/stage-two';
import { StageThree } from '../loan-stages/stage-3/stage-three';
import { StageFive } from '../loan-stages/stage-5/stage-five';
import { StageSeven } from '../loan-stages/stage-7/stage-seven';
import { StageEight } from '../loan-stages/stage-8/stage-eight';
import { useLoanProcessStore } from '../store/loan-process.store';

export function useLoanProcessView() {
  const { merchantResponseData } = useMainHubStoreState();
  const {
    state: { applicationFormData, currentStage, loanData, loanLimit, loanSMSIds },
  } = useLoanProcessStore();

  if (currentStage === 0) {
    return (
      <StageZero
        applicationFormData={applicationFormData}
        merchantResponseData={merchantResponseData}
        loanLimit={loanLimit}
      />
    );
  }
  if (currentStage === 1) {
    if (loanData?.provider === 'liberis') {
      return <StageOneLiberis />;
    }

    return <StageOne merchantResponseData={merchantResponseData} loanData={loanData} />;
  }
  if (currentStage === 2) {
    return (
      <StageTwo
        merchantResponseData={merchantResponseData}
        loanData={loanData}
        loanLimit={loanLimit}
      />
    );
  }
  if (currentStage === 3) {
    return (
      <StageThree
        merchantResponseData={merchantResponseData}
        loanData={loanData}
        loanSMSIds={loanSMSIds}
      />
    );
  }
  if (currentStage === 4) {
    // Stage 4 represent the same view as stage 3
    return (
      <StageThree
        merchantResponseData={merchantResponseData}
        loanData={loanData}
        loanSMSIds={loanSMSIds}
      />
    );
  }
  if (currentStage === 5) {
    return <StageFive />;
  }
  if (currentStage === 7) {
    return <StageSeven />;
  }
  if (currentStage === 8) {
    return <StageEight />;
  }

  return null;
}
